import { Separator } from "@chakra-ui/react-v3";
import { DiagnosticReportRowData } from "../tables/notes/diagnostic-reports-rows";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { NoteDisplay } from "../components/note-display";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { ResourceAnalysis } from "../components/resource-analysis";

export type NoteSidePanelContentProps = {
  data: DiagnosticReportRowData;
  resourceType: "DiagnosticReport" | "ImagingReports";
};

/**
 * Side panel content for notes (DiagnosticReport/ImagingReports).
 * Shows AI analysis, the note content, and source documents.
 * Close button is handled generically by SidePanelDrawer.
 */
export function NoteSidePanelContent({ data, resourceType }: NoteSidePanelContentProps) {
  return (
    <SidePanelLayout
      title={data.typeOfReport}
      subtitle={`${data.noteCategory} - ${data.specialty}`}
      metadata={data.date}
    >
      {/* AI Analysis Section (if available) */}
      <ResourceAnalysis />

      {/* Note Display Section */}
      <NoteDisplay resource={data.originalData} />

      <Separator borderColor="border" />

      {/* Documents Section */}
      <DocumentsSection resources={[data.originalData]} resourceType={resourceType} />
    </SidePanelLayout>
  );
}
